module.exports = __webpack_public_path__ + "static/media/native-script.c65e3746.png";